import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, IconButton, Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send'
import SaveIcon from '@mui/icons-material/Save';

import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { useValue } from '../../../context/ContextProvider';
import { EnviarNuevoProveedor, actualizarProveedor } from '../../../actions/proveedores';
import { MuiTelInput } from 'mui-tel-input';

const NuevoProveedor = ({ openNuevoProveedor, setOpenNuevoProveedor, isUpdate, setIsUpdate, oldRow, proveedores, editRowId, setEditRowId }) => {
    const razonSocialRef = useRef();
    const nomContactoRef = useRef();
    const descRef = useRef();
    const prodRef = useRef();
    const habRef = useRef();
    const [proveedorState, setProveedorState] = useState('');
    const [telfEmpresa, setTelfEmpresa] = useState('');
    const [nombreContacto, setNombreContacto] = useState('');
    const [telfContacto, setTelfContacto] = useState('');
    const [diasVisita, setDiasVisita] = useState([]);
    const [habCheck, setHabCheck] = useState(true);
    const { state: { currentUser, marcas }, dispatch } = useValue();


    //var oldRow ={};

    useEffect(() => {
        //console.log('useEffect NuevoProveedor');
        if(editRowId > 0) {
            setIsUpdate(true);
            //oldRow = proveedores.find((p) => p.id == editRowId);
            oldRow.enF == 1 ? setHabCheck(true) : setHabCheck(false);
            setProveedorState(oldRow.proveedor);
            setTelfEmpresa(oldRow.telfEmpresa);
            setNombreContacto(oldRow.nombreContacto);
            setTelfContacto(oldRow.telfContacto);
            setDiasVisita(oldRow.diasVisita);
            //console.log({oldRow});
        } else {
            setIsUpdate(false);
            setHabCheck(true);
            setProveedorState('');
            setTelfEmpresa('+591 ');
            setNombreContacto('');
            setTelfContacto('+591 ');
            setDiasVisita('');
            setDiasVisita([]);
        }
        
    }, [openNuevoProveedor])

    const handleClose = () => {
        setOpenNuevoProveedor(false);
        //console.log({ diasVisita, proveedores, editRowId, oldRow });
        setEditRowId(0);    //Significa ninuna fila editandose
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const datos = {
            isUpdate: isUpdate,
            id: isUpdate ? oldRow.id : 0,
            proveedor: razonSocialRef.current.value,
            descripcion: descRef.current.value,
            nombreContacto: nomContactoRef.current.value,
            telfContacto: telfContacto,
            telfEmpresa: telfEmpresa,
            productos: prodRef.current.value,
            diasVisita: diasVisita,
            enF: habCheck
        }

        //console.log(datos);
        
        try {
            if(isUpdate) {
                const result = await actualizarProveedor(datos, currentUser, dispatch);
                console.log("Respuesta del servidor: ", result.rows);
                const newProveedores = proveedores.map((p) => 
                    p.id == editRowId ? result.rows[0] : p
                )
                //setProveedores(newProveedores);
                dispatch({ type: 'UPDATE_PROVEEDORES', payload: {rows: newProveedores }});
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Proveedor actualizado con éxito." } });

            } else {
                //const result = await EnviarNuevoProveedor(datos, currentUser, dispatch, setProveedores);
                const result = await EnviarNuevoProveedor(datos, currentUser, dispatch);
                //console.log("Respuesta del servidor: ", result.rows);
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Proveedor creado con éxito." } });
            }
            
            /*
            let nuevaFila = null;
            let mensaje = null;

            if (isUpdate) {
                //Codigo para actualiza un objeto que está en el array de marcas
                marcasActualizadas = marcas.map(element => element.id == result.rows[0].id ? result.rows[0] : element);
                mensaje = 'Se actualizó la marca con éxito.'
            } else {
                marcasActualizadas = [...marcas, result.rows[0]];
                mensaje = 'Se creo la marca con éxito.'
            }
            console.log("Tabla marcas actualizada: ", marcasActualizadas);
            dispatch({ type: 'UPDATE_MARCAS', payload: { rows: marcasActualizadas } });
            */
            setOpenNuevoProveedor(false);
            //dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Proveedor creado con éxito." } });

        } catch (error) {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Error M040: No se pudo crear el nuevo proveedor. Compruebe su conexión.' } });
        }
    }

    const handleTelfEmpresaChange = (newValue) => {
        setTelfEmpresa(newValue)
    }

    const handleTelfChange = (newValue) => {
        setTelfContacto(newValue)
    }

    const handleVisitaFormat = (event, newFormats) => {
        setDiasVisita(newFormats);
    };

    return (
        <Dialog
            open={openNuevoProveedor}
            onClose={handleClose}
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle>
                {isUpdate ? 'Editar Proveedor' : 'Nuevo Proveedor'}
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={handleClose}
                >
                    <CancelIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <DialogContentText paddingBottom={2}>
                        {isUpdate ? 'Puede editar los siguientes campos:' : 'Por favor llene los siguientes campos:'}
                    </DialogContentText>

                    <Divider textAlign="left">Empresa</Divider>

                    <Stack direction='row' spacing={2} paddingTop={2} paddingBottom={1}>
                        <TextField
                            autoFocus
                            margin='normal'
                            variant='outlined'
                            id='proveedor'
                            label='Razón Social'
                            type='text'
                            fullWidth
                            inputRef={razonSocialRef}
                            inputProps={{ minLength: 2 }}
                            value={proveedorState}
                            sx={{ width: '70%' }}
                            onChange={(e) => setProveedorState(e.target.value)}
                            disabled={isUpdate}
                        //helperText='Razón social'
                        />
                        <MuiTelInput value={telfEmpresa} label='Telf/Cel Empresa' onChange={handleTelfEmpresaChange} />
                    </Stack>

                    <Stack direction='row' spacing={2} paddingTop={1} paddingBottom={3}>
                        <TextField
                            margin='normal'
                            variant='outlined'
                            id='desc'
                            type='text'
                            label='Descripcion'
                            fullWidth
                            inputRef={descRef}
                            inputProps={{ minLength: 6 }}
                            multiline
                            rows={2}
                            defaultValue={isUpdate ? oldRow?.descripcion : ''}
                        />
                    </Stack>

                    <Divider textAlign="left">Contacto</Divider>

                    <Stack direction='row' spacing={2} paddingTop={2} paddingBottom={3}>
                        <TextField
                            margin='normal'
                            variant='outlined'
                            id='nomContacto'
                            label='Nombre del contacto'
                            type='text'
                            fullWidth
                            inputRef={nomContactoRef}
                            value={nombreContacto}
                            inputProps={{ minLength: 3 }}
                            required
                            onChange={(e) => setNombreContacto(e.target.value)}
                            //defaultValue={isUpdate ? oldRow?.nombreContacto : ''}
                            sx={{ width: '70%' }}
                        //helperText='Nombre del contacto'
                        />

                        <MuiTelInput value={telfContacto} label='Cel Contacto' onChange={handleTelfChange} />
                    </Stack>

                    <Divider textAlign="left">Info adicional</Divider>

                    <Stack direction='row' spacing={2} paddingTop={2}>
                    <TextField
                            margin='normal'
                            variant='outlined'
                            id='productos'
                            type='text'
                            label='Productos que distribuye'
                            fullWidth
                            inputRef={prodRef}
                            inputProps={{ minLength: 6 }}
                            multiline
                            rows={2}
                            defaultValue={isUpdate ? oldRow?.productos : ''}
                        />
                        
                        <Stack direction='column'>
                            <Typography variant='p'>Días de visita</Typography>
                        <ToggleButtonGroup
                            value={diasVisita}
                            onChange={handleVisitaFormat}
                            aria-label="text formatting"
                        >
                            <ToggleButton size='small' value="Lun" aria-label="Lunes"><h2>L</h2></ToggleButton>
                            <ToggleButton size='small' value="Mar" aria-label="Martes"><h2>M</h2></ToggleButton>
                            <ToggleButton size='small' value="Mie" aria-label="Miércoles"><h2>M</h2></ToggleButton>
                            <ToggleButton size='small' value="Jue" aria-label="Jueves"><h2>J</h2></ToggleButton>
                            <ToggleButton size='small' value="Vie" aria-label="Viernes"><h2>V</h2>
                            </ToggleButton><ToggleButton size='small' value="Sab" aria-label="Sábado"><h2>S</h2></ToggleButton>
                        </ToggleButtonGroup>
                        </Stack>
                    </Stack>


                    {isUpdate && <FormControlLabel control={
                        <Checkbox
                            checked={habCheck}
                            inputRef={habRef}
                            onChange={() => setHabCheck(!habCheck)}
                        />
                    } label="Registro habilitado" />}

                </DialogContent>
                <DialogActions sx={{ pr: '22px', pt: '20px' }}>
                    <Button onClick={handleClose} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button type='submit' variant='contained' startIcon={<SaveIcon />}>
                        Guardar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>

    )
}

export default NuevoProveedor

